import { render, staticRenderFns } from "./editLearningCentre.vue?vue&type=template&id=d237fe16&scoped=true&"
import script from "./editLearningCentre.vue?vue&type=script&lang=js&"
export * from "./editLearningCentre.vue?vue&type=script&lang=js&"
import style0 from "./editLearningCentre.vue?vue&type=style&index=0&id=d237fe16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d237fe16",
  null
  
)

export default component.exports